// @flow
import React, { Component, Fragment } from 'react';
import { CommonActions } from 'store/actionCreators';
import type { State } from 'store';
import { connect } from 'react-redux';
import { type CategoryData } from 'store/modules/common';
import CategoryItemList from 'components/categories/CategoryItemList/CategoryItemList';

type OwnProps = {
  sort: string,
  supplier: string,
};

type Props = OwnProps & {
  categories: ?(CategoryData[]),
};

class CategoryItemListContainer extends Component<Props> {
  initialize = () => {
    const { sort } = this.props;
    const { categories } = this.props;
    if (!categories || categories.length === 0) {
      CommonActions.getCategories();
    } 
  };
  
  componentDidMount() {
    this.initialize();
  }

  onSelectCategory = (info: CategoryData) => {
    CommonActions.setCategoryInfo(info);
  };

  // componentDidUpdate(prevProps) {
  //   if (prevProps.sort !== this.props.sort) {
  //     this.initialize();
  //   }
  // }

  render() {
    const { categories } = this.props;
    if (!categories) return null;
    const categoryList = categories.filter(doc => doc.order === 1);
    const categoryList1 = categories.filter(doc => doc.order === 2);

    return (
      <Fragment>
        <CategoryItemList
          categories={categoryList}
          categories1={categoryList1}
          onSelectCategory={this.onSelectCategory}
        />
      </Fragment>
    );
  }
}

export default connect(
  ({ common }: State) => ({
    categories: common.categories.data,
  }),
  () => ({}),
)(CategoryItemListContainer);



// WEBPACK FOOTER //
// ./src/containers/categories/CategoryItemListContainer.js